import { useState } from 'react';
import useStateConSessione from 'utils/useStateConSessione'
import useStepApi from '../useStep';
import { useSessione } from 'context/SessioneProvider';
import { SERVIZIO_FRONTOFFICE } from '../utilFrontoffice'


 const STEPS = {
  INFORMATIVA: "informativa",
  DATI_PERSONALI: "dati_personali",
  DATI_VERBALE: "dati_verbale",
  CODICE_AVVISO: "codice_avviso",
  CHIAVE_VERBALE: "chiave_varbale",
};
 const step_key_generators = {
  [STEPS.INFORMATIVA]: (chiaveScelta) => `frontoffice_informativa`,
  [STEPS.DATI_PERSONALI]: (chiaveScelta) => 'frontoffice_datiPersonaliCf',
  [STEPS.DATI_VERBALE]: (chiaveScelta) => `frontoffice_${chiaveScelta}_datiVerbaleVisti`,
  [STEPS.CODICE_AVVISO]: (chiaveScelta) => `frontoffice_${chiaveScelta}_codiceAvvisoScelto`,
  [STEPS.CHIAVE_VERBALE]: (chiaveScelta) => `frontoffice_chiaveScelta`,
}

 const step_key_options = {
  [STEPS.INFORMATIVA]: (chiaveScelta) => ({}),
  [STEPS.DATI_PERSONALI]: (chiaveScelta) => ({}),
  [STEPS.DATI_VERBALE]: (chiaveScelta) => ({ rimuoviSe: !chiaveScelta }),
  [STEPS.CODICE_AVVISO]: (chiaveScelta) => ({ rimuoviSe: !chiaveScelta }),
  [STEPS.CHIAVE_VERBALE]: (chiaveScelta) => ({ })
}
 function keyMaker(step, chiaveScelta){
  const fn = step_key_generators[step];
  if (!fn) {
  throw new Error(`Chiave non supportata: ${step}`);
  }
  return fn(chiaveScelta);
 }

export function useRestoreStepVerbale(){
  
  const {getSteps} = useStepApi(SERVIZIO_FRONTOFFICE)
  const { salvaInSessione } = useSessione()
  async function build(idPratica){
    const resp = await getSteps(idPratica)
    if(resp.ok){
      resp?.data?.data?.forEach(({step,idPratica,extra}) => {
        if(![STEPS.CODICE_AVVISO].includes(step)){
          salvaInSessione(keyMaker(step, idPratica), extra)
        }      
      })
    }

  }

 
  
  
  return {build}
}


function useStepState(initialValue, step, chiaveVerbale, sendStepVerbale) {
  const key = keyMaker(step, chiaveVerbale);
  const options = step_key_options[step]( chiaveVerbale);
  const [value, _setValue] = useStateConSessione(initialValue, key, options);

  const setter = (newValue) => {
    _setValue(newValue);
    sendStepVerbale?.(step, chiaveVerbale, newValue)
  };

  return [value, setter];
}

export default function useStepVerbale({
  codiceFiscale = null,
  chiaveVerbale,
  //chiaveScelta,
}) {
  const [chiaveScelta, setChiaveScelta] = useStepState(chiaveVerbale, STEPS.CHIAVE_VERBALE, chiaveVerbale, sendStepVerbale, codiceFiscale);
  const [informativaAccettata, setInformativaAccettata] = useStepState(false, STEPS.INFORMATIVA, chiaveScelta, sendStepVerbale, codiceFiscale);
  const [datiPersonaliCf, setDatiPersonaliCf] = useStepState(codiceFiscale ? "" : "__ANONIMO__", STEPS.DATI_PERSONALI, chiaveScelta, sendStepVerbale, codiceFiscale); 
  const [datiVerbaleVisti, setDatiVerbaleVisti] = useStepState(false, STEPS.DATI_VERBALE, chiaveScelta, sendStepVerbale, codiceFiscale);
  const [codiceAvvisoScelto, setCodiceAvvisoScelto] = useStepState("", STEPS.CODICE_AVVISO, chiaveScelta, sendStepVerbale, codiceFiscale);

  const {sendSteps} = useStepApi(SERVIZIO_FRONTOFFICE)

  const [stepIncompleti, setStepIncompleti] = useState({})

  function sendStepVerbale(step, chiave, data){
    if(codiceFiscale){
      if(!chiave){
        setStepIncompleti(prev => {
          const key = `${step}_${codiceFiscale}`;
          if (prev[key]?.data === data) return prev;
          return { ...prev, [key]: {step, codiceFiscale, chiave, data} };
        })
        
      }else{ // keyMaker lo si fa adesso o quando si torna e si ricostruisce lo stato, forse + pulita la seconda
        
        let steps = []
        Object.keys(stepIncompleti).forEach((key) => 
          steps.push({ step:stepIncompleti[key].step, idPratica:chiave, extra: stepIncompleti[key].data})
        )
        steps.push({ step:step, idPratica:chiave, extra:data})
        
        sendSteps(steps) 
      }
    }

  }
  



  return {
    informativaAccettata,
    setInformativaAccettata,

    datiPersonaliCf,
    setDatiPersonaliCf,

    chiaveScelta,
    setChiaveScelta,

    datiVerbaleVisti,
    setDatiVerbaleVisti,

    codiceAvvisoScelto,
    setCodiceAvvisoScelto,
  };
}




